import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import { getProfile } from '@/utils'
import merge from 'deepmerge'

const profile = getProfile()
const module = 'newnotifications'
let doc = {
  list: {
    name: 'Notifications',
  },

  form: {},
  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    fetchAll: ({ commit }, payload) => {
      commit('LIST_REQUEST', payload)
      apiClient.fetchCustom(module, `notifications/user/${profile.sub}/new`, {bust: Date.now()})
        .then(data => {
          if (data === 'cached') {
            commit('LIST_NOT_MODIFIED')
          } else {
            commit('LIST_SUCCESS', data)
          }
        })
        .catch(error => {
          commit('LIST_ERROR', error)
        })
    },
  },
}
export default merge(base, custom)
